import React from 'react';
import { XCircle, CheckCircle, ArrowRight } from 'lucide-react';
export function ProductIntroSection() {
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-241">
      <div className="max-w-5xl mx-auto" data-id="element-242">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-243">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5a] mb-4" data-id="element-244">
            Pensado para docentes de secundaria
          </h2>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-245">
            <span className="bg-[#FDF6E3] px-4 py-2 rounded-full text-sm font-semibold text-[#d4a853] border border-[#d4a853]/20" data-id="element-246">
              ✓ Cursos reales
            </span>
            <span className="bg-[#FDF6E3] px-4 py-2 rounded-full text-sm font-semibold text-[#d4a853] border border-[#d4a853]/20" data-id="element-247">
              ✓ Problemas reales
            </span>
            <span className="bg-[#FDF6E3] px-4 py-2 rounded-full text-sm font-semibold text-[#d4a853] border border-[#d4a853]/20" data-id="element-248">
              ✓ Tiempos reales
            </span>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-249">
          {/* What doesn't work */}
          <div className="bg-red-50 p-6 rounded-2xl border border-red-100" data-id="element-250">
            <h3 className="text-lg font-bold text-red-700 mb-4 flex items-center gap-2" data-id="element-251">
              <XCircle className="w-5 h-5" data-id="element-252" /> Lo que NO funciona
            </h3>
            <ul className="space-y-3" data-id="element-253">
              <li className="flex items-start gap-3 text-gray-700" data-id="element-254">
                <span className="text-red-500 mt-1" data-id="element-255">✗</span>
                <span data-id="element-256">
                  <strong data-id="element-257">Manuales escolares:</strong> Teoría sin bajada
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-258">
                <span className="text-red-500 mt-1" data-id="element-259">✗</span>
                <span data-id="element-260">
                  <strong data-id="element-261">PDFs de internet:</strong> Sin orden pedagógico
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-262">
                <span className="text-red-500 mt-1" data-id="element-263">✗</span>
                <span data-id="element-264">
                  <strong data-id="element-265">Armar desde cero:</strong> Consume tiempo
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-266">
                <span className="text-red-500 mt-1" data-id="element-267">✗</span>
                <span data-id="element-268">
                  <strong data-id="element-269">PPTs "lindos":</strong> Visuales, no pedagógicos
                </span>
              </li>
            </ul>
          </div>

          {/* What works */}
          <div className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-270">
            <h3 className="text-lg font-bold text-green-700 mb-4 flex items-center gap-2" data-id="element-271">
              <CheckCircle className="w-5 h-5" data-id="element-272" /> Política y Ciudadanía 360
            </h3>
            <ul className="space-y-3" data-id="element-273">
              <li className="flex items-start gap-3 text-gray-700" data-id="element-274">
                <span className="text-green-500 mt-1" data-id="element-275">✓</span>
                <span data-id="element-276">
                  <strong data-id="element-277">Ordena todo el año</strong>
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-278">
                <span className="text-green-500 mt-1" data-id="element-279">✓</span>
                <span data-id="element-280">
                  <strong data-id="element-281">Traduce la teoría al aula</strong>
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-282">
                <span className="text-green-500 mt-1" data-id="element-283">✓</span>
                <span data-id="element-284">
                  <strong data-id="element-285">Genera participación real</strong>
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-286">
                <span className="text-green-500 mt-1" data-id="element-287">✓</span>
                <span data-id="element-288">
                  <strong data-id="element-289">Funciona en secundaria</strong>
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center bg-[#FDF6E3] p-8 rounded-2xl border border-[#d4a853]/20" data-id="element-290">
          <p className="text-xl font-bold text-[#1e3a5a] mb-2 flex items-center justify-center gap-2" data-id="element-291">
            Abrís el archivo <ArrowRight className="w-5 h-5 text-[#d4a853]" data-id="element-292" />{' '}
            Das la clase <ArrowRight className="w-5 h-5 text-[#d4a853]" data-id="element-293" />{' '}
            <span className="text-[#d4a853]" data-id="element-294">Listo.</span>
          </p>
        </div>
      </div>
    </section>;
}